import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import PropTypes from 'prop-types';
import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';

const ModalAgregarEditarPlan = ({ show, onHide, idCliente, planInicial, onGuardado }) => {
    const { token, setToken } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();

    const modoEdicion = !!planInicial;
    const [rfcNuevoPlan, setRfcNuevoPlan] = useState('');
    const [idPlanFacturaMx, setIdPlanFacturaMx] = useState('');
    const [guardandoPlan, setGuardandoPlan] = useState(false);

    useEffect(() => {
        if (show) {
            setRfcNuevoPlan(planInicial?.vRfc || '');
            setIdPlanFacturaMx(planInicial?.idPlanFacturaMx || '');
        }
    }, [show, planInicial]);

    const handleGuardar = async () => {
        if (!rfcNuevoPlan.trim()) {
            showErrorToast('Por favor ingrese un RFC válido');
            return;
        }

        setGuardandoPlan(true);
        try {
            const response = await fetch('/api/cliente/WSFacturacionMXAuthInsertUpdate', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    idClienteAkasia: idCliente,
                    rfc: rfcNuevoPlan.trim(),
                    idPlanFacturaMx: idPlanFacturaMx || null,
                    bIsActive: true
                })
            });

            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType === 1) {
                    showSuccessToast(modoEdicion ? 'Plan actualizado exitosamente' : 'Plan de facturación agregado exitosamente');
                    if (onGuardado) onGuardado();
                    onHide();
                } else {
                    showErrorToast(data.vMessage || 'Error al guardar el plan');
                }
            } else {
                if (response.status === 401) {
                    setToken(null);
                    location.href = '';
                }
                const errorData = await response.json().catch(() => ({}));
                showErrorToast(errorData.vMessage || `Error ${response.status}: ${response.statusText}`);
            }
        } catch (error) {
            showErrorToast('Error al guardar el plan: ' + error.message);
        } finally {
            setGuardandoPlan(false);
        }
    };

    return (
        <Modal show={show} centered onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{modoEdicion ? 'Editar Plan de Facturación' : 'Agregar Plan de Facturación'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group className="mb-3">
                    <Form.Label>RFC</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Ingrese el RFC..."
                        value={rfcNuevoPlan}
                        onChange={(e) => setRfcNuevoPlan(e.target.value.toUpperCase())}
                        maxLength={13}
                    />
                    <Form.Text className="text-muted">
                        Ingrese el RFC al que se asociará el plan de facturación
                    </Form.Text>
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cancelar
                </Button>
                <Button
                    variant="primary"
                    onClick={handleGuardar}
                    disabled={guardandoPlan || !rfcNuevoPlan.trim()}
                >
                    {guardandoPlan ? (
                        <>
                            <Spinner animation="border" size="sm" className="me-2" />
                            Guardando...
                        </>
                    ) : (
                        'Guardar'
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

ModalAgregarEditarPlan.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    idCliente: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    planInicial: PropTypes.object,
    onGuardado: PropTypes.func
};

export default ModalAgregarEditarPlan;
